export default class AEEEventList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}
	}

	static async fetch (aee_id) {
		let data = await Anvil.REST.get(`/c_order/aee/${aee_id}/event`)
		return new AEEEventList(data)
	}

	getById (id) {
		return this.index[id]
	}
}
